<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
<!-- LEAGUE HEADER + ACTIVE DRAFTS DESKTOP -->
<style>
  .material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}
.material-icons-outlined,
.material-icons.material-icons--outlined {
	@extend .material-icons;
	font-family: "Material Icons Outlined";
}
   .material-symbols-outlined {
    font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
  } 
  .material-symbols-outlined.active {
    font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
  }
   
.photo_camera {
  cursor: pointer;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 48
}
.photo_camera:hover {
  font-variation-settings:
  'FILL' 1,
  'wght' 400,
  'GRAD' 0,
  'opsz' 48
}
.shareBtn:hover .photo_camera {
  font-variation-settings:
  'FILL' 1,
  'wght' 400,
  'GRAD' 0,
  'opsz' 48
}
  </style>
<div class="headerDesktop" [ngClass]="{'active-draft':isActiveDraft}" *ngIf="!isMobile">
  <!-- <app-activedraft (emitPass)="activeDraftCount($event)"></app-activedraft> -->
  <app-active-drafts2 *ngIf="!isMobile"></app-active-drafts2>
  <div class="leagueHeader">
    <div class="body">
      <div class="leagueName">
        <a [href]="lobbyURL" class="back">
          <i class="fas fa-chevron-left"></i>
        </a>
        <div class="icon" [ngStyle]="{'background-image':'url(\''+bucketURL+league?.lg_abbr+'_icon'+darkMode_ext+'.svg\')'}"></div>
      <span>{{ league?.name }} </span> 
      <!-- <span class="status">{{getLeagueStatus()}}</span> -->
      </div>
      <div class="siteLogo">
        <a href="{{siteURL}}">
            <img *ngIf="darkMode" src="assets/images/logo.png" alt="">
            <img *ngIf="!darkMode" src="assets/images/logo-red.png" alt="">
        </a>
      </div>
      <div class="leagueMenu">
        <span class="dark-theme-toggle">
          <label for="checkbox" class="label">
            <input type="checkbox"  style="cursor: pointer;" class="checkbox" (click)="toggleDarkTheme()" id="checkbox">
            <i class="fas fa-moon" *ngIf="darkMode"></i>
            <i class='far fa-moon'  *ngIf="!darkMode"></i>
          </label>
        </span>
        <a class="menuItem" [href]="leagueURL" *ngIf="leagueURL != ''">League</a>
        <a class="menuItem" [href]="myTeamURL" *ngIf="myTeamURL != '' && pickInfoBox?.status == 4">My Team</a>
        <a class="menuItem" [href]="matchupURL" *ngIf="matchupURL != '' && pickInfoBox?.status == 4">Matchup</a>
        <!-- <a class="menuItem" [href]="playersURL" *ngIf="playersURL != ''">Players</a> -->
        <a class="menuItem active" [routerLink]="draftURL" *ngIf="draftURL != ''">Draft</a>
        <a class="menuItem" [href]="settingsURL" *ngIf="settingsURL != ''">Settings</a>
      </div>
    </div>
  </div>
</div>
<!-- SLIDER -->
<div class="sliderContainer" *ngIf="currentView == 'slider'" #sliderContainer
  [@openSlider]="{'value': (!isMobile)?((selectedTab != 4)?sliderState:'close'):'open', 'params':{'adj_height':(sliderContainer.scrollWidth > sliderContainer.clientWidth)?(100+scrollBarHeight)+'px':'100px','half_height':(sliderContainer.scrollWidth > sliderContainer.clientWidth)?(42+scrollBarHeight)+'px':'42px'}}"
  (scroll)="updateSliderScroll($event)">
  <div class="slide" #curSlide *ngFor="let slide of slider" (click)="getDraftSummry(slide?.lgm_id)"
    (mouseover)="updateHoverStyle(curSlide,slide?.lgm_id,$event)" (mouseout)="hoverStyle.display = 'none'">
    <div class="body" *ngIf="isVisible(slide,sliderContainer)">
      <div class="left">
        <div class="pick_num">{{ (slide?.round -1) * (draftData?.lgm.length) + slide?.pick }}</div>
      </div>
      <div class="team" [ngStyle]="{'z-index:':league?.game_id ==2?'999':'','position':league?.game_id ==2?'relative':''}">{{ slide?.team_name }}</div>
      <div class="timer" [ngStyle]="{'color':(pickInfoBox?.status == 3 && timeleft < 15)?'#DD0000':'rgb(20, 170, 30)'}"
        *ngIf="currentPick == slide?.total_pick && (pickInfoBox?.status == 3 || pickInfoBox?.status == 5)">
        {{ (pickInfoBox?.status == 3 || pickInfoBox?.auto_pause == 1)?getPickClock(timeleft):'Pause' }}</div>
      <div [ngClass]="{'userImg' : (slide?.player_id == null),'userImg2' : (slide?.player_id != null)}"
        [ngStyle]="{'background-image':'url(\''+((slide?.player_id != null)?slide?.player_picture:slide?.team_picture)+'\')','height':'48px', 'width':'50px'}"
        *ngIf="currentPick != slide?.total_pick || (pickInfoBox?.status != 3 && pickInfoBox?.status != 5)"></div>
    </div>
  </div>
  <div class="sliderPlayers" *ngIf="pickInfoBox?.status > 2">
    <ng-container *ngFor="let slide of slider; let i=index;">
      <div class="player" *ngIf="currentPick >= slide?.total_pick"
        [ngClass]="{'infobox':currentPick > slide?.total_pick}"
        (click)="openPlayerInfoBox(slide?.player_id,tablePlayers,false,{})">
        <div class="pContainer" [ngStyle]="{'background-color':slide?.bgColor}">
          <div class="text" [ngStyle]="{'color':getRGBAColor(draftData?.textColor)}">{{ getPickBar(slide) }}</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- HOVER ROSTER CONSTRUCTION -->
<div class="hoverRoster" [ngStyle]="hoverStyle">
  <div class="body">
    <div class="line" *ngFor="let line of hoverRoster">
      <div class="position">
        <div class="p">{{ line.position }}:</div>
      </div>
      <div class="values">{{ line.filled }}/{{ line.total }}</div>
    </div>
  </div>
</div>
<!-- TABLE -->
<div class="tableContainer" *ngIf="currentView == 'table'" #tableContainer (scroll)="updateTableScroll($event)">
  <div class="tableButtons">
    <div class="more" (click)="changeTableRows(true)"><i class="fas fa-plus"></i>
    </div>
    <div class="less" (click)="changeTableRows(false)"><i class="fas fa-minus"></i></div>
    <div class="less" matTooltip="Locate Active Pick" matTooltipPosition="above" (click)="resetTableRowsView()"><span style="font-size:13px;" class="" [ngClass]="!showResetIcon?'material-icons':'material-symbols-outlined'">near_me</span></div>
  </div>
  <div class="tableC" #tContainer (scroll)="resultrBoardScrollEvent($event)" [ngStyle]="{'max-height':tableCHeight}">
    <div class="leagueMembers" [ngStyle]="{'width':getTableHeaderWidth(tContainer,tableContainer)}">
      <div class="roundSpacer"></div>
      <div class="leagueMember" #leagueMember *ngFor="let lgm of draftData?.lgm">
       <div (click)="getDraftSummry(lgm.team_id)" (mouseover)="updateHoverStyle(leagueMember,lgm.team_id,$event)" (mouseout)="hoverStyle.display = 'none'">
          <h3 class="teamName">{{ lgm?.team_name }}</h3>
          <div class="image" [ngStyle]="{'background-image':'url(\''+lgm.imageUrl+'\')'}"></div>
       </div>
       <div class="roster" *ngIf="league && league?.duration_id == 10"> 
          <div class="dpRoasterData scrollTable" *ngIf="getRosterData[lgm.team_id]">
            <div style="display:inline-block" *ngFor="let rplist of getRosterData[lgm.team_id]">
              <div class="rpBody rosterPosition" [ngStyle]="{'color':rplist.bgcolor,'display':'inline-block'}">{{ rplist.position }}</div>
              <div class="count">{{rplist.filled}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tRow" *ngFor="let round of pickOrder;let i = index;">
      <div class="roundNumber">R{{ (i+1) }} </div>
      <ng-container *ngFor="let pick of round" style="display:inline-block;">
        <div class="pick" [ngStyle]="{'background-color':pick.bgColor, 'color':getRGBAColor(draftData?.textColor)}"
          *ngIf="pick.player != null">
          <div class="body">
            <div style="display: flex;">
              <div class="name" (click)="openPlayerInfoBox(pick.player_id,tablePlayers,false,{})"
                style="display: inline-block;width: 80%;text-align: left;" [ngStyle]="{'font-size':pick.player.length>12?'10px':''}">{{ pick.player }}</div>
              <div class="round" style="display: inline-block;width: 20%;text-align: right;">{{ (pick.round - 1) *
                (draftData?.lgm.length) + pick.pick }}</div>
            </div>
            <div class="left">{{ pick.team }} <span
                *ngIf="(league?.game_id == 2 && league?.duration_id == 8 && league?.bestball_playoff == 0)"> {{
                pick?.bye_week
                }}</span>
            </div>
            <div class="right">{{ getPosition(pick.p_pos) }}</div>
          </div>
        </div>
        <div class="pickEmpty"
        [ngStyle]="{'background-color':(pickInfoBox?.status == 3 && currentPick == pick.total_pick)?darkMode?'green':'rgb(240,240,240)':(currentPick == pick.total_pick)?'green':darkMode?'#10171E':'rgb(240,240,240)'}"
          *ngIf="pick.player == null">
          <div class="bodyActive"
            [ngStyle]="{'color':(pickInfoBox?.status == 3 && timeleft < 15)?'#DD0000':'rgb(20, 170, 30)'}"
            *ngIf="(pickInfoBox?.status == 3 || pickInfoBox?.status == 5) && currentPick == pick.total_pick; else elseBlock">
            <div class="clock"><i class="fas fa-clock"></i></div>
            <div class="count">{{ (pickInfoBox?.status == 3 || pickInfoBox?.auto_pause == 1)?getPickClock(timeleft):'Pause' }}</div>
          </div>
          <ng-template #elseBlock>
            <div class="body" [ngClass]="{'activeUser': user.id == pick.user_id }">
              {{ (pick.round - 1) * (draftData?.lgm.length) + pick.pick }}
            </div>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<!-- BODY -->
<div class="main" *ngIf="!isMobile" [ngClass]="{content_shadow:currentView != 'slider'}">
  <div class="message" [@openMessage]="{'value':isMessage}"
    [ngClass]="{'active':(pickInfoBox?.status == 3 || pickInfoBox?.auto_pause == 1) && slider[currentPick-1]?.lgm_id ==draftData?.myteam_id }">
    <div class="predraft" *ngIf="pickInfoBox?.status == 2">
      <i class="far fa-clock"></i> {{getPickClock(timeleft)}}
      <mat-checkbox [disabled]="readyBox.im_ready" style="margin-left:10px;" (change)="imReady($event)"
        *ngIf="readyBox.status != 0">
        {{ readyBox.message }}</mat-checkbox>
    </div>
    <div class="draftComplete" *ngIf="pickInfoBox?.status == 4">
      DRAFT COMPLETED <i class="check fas fa-check-circle"></i>
    </div>
    <div class="draftPaused" *ngIf="pickInfoBox?.status == 5 && pickInfoBox?.auto_pause == 0">
      DRAFT PAUSED <i class="pause fas fa-pause-circle"></i>
    </div>
    <!-- <div class="totalPlayers"
      *ngIf="(pickInfoBox?.status == 3 || pickInfoBox?.status == 5) && league?.duration_id == 8 && !isAutoPick">
      TOTAL PLAYERS: {{ myPlayersCount() }}/{{ league?.total_players }}
    </div> -->
    <div class="draftPick" *ngIf="(pickInfoBox?.status == 3 ||  pickInfoBox?.auto_pause == 1)  && !isAutoPick">
      <span class="clock"><i class="far fa-clock"></i> {{ getPickClock(timeleft) }}</span>{{ getPickMessage() }}
    </div>
    <div class="autopick" *ngIf="isAutoPick" (click)="disableAutoPick()">
      <i class="fas fa-exclamation-triangle"></i> Autopick Mode: Click here to disable <i
        class="fas fa-exclamation-triangle"></i>
    </div>
  </div>
  <div class="innerMain"  [ngClass]="(isMac)?'macOS':'otherOS'">   
    <!-- POSITION FILTERS -->
        <div class="l-f-section" style="display: flex;width: 60%;justify-content: space-between;">
              <div class="filters scrollTable" #filters
                [ngStyle]="{'height':(filters.scrollWidth > filters.clientWidth)?(50+7)+'px':'50px'}">
                <div class="filter" *ngFor="let rp of draftData?.roster_position"
                  [ngStyle]="(availRoster(rp.pname))?getStyle(rp.pname):filledPosition"
                  [ngClass]="{'filled':!availRoster(rp.pname)}" (click)="(availRoster(rp.pname))?setFilters(rp):null">
                  <div class="position" [ngStyle]="{'padding-top':(rp.tpick>0)?'5px':'8px'}">{{ rp.pname }}</div>
                  <div class="picked" *ngIf="rp.tpick > 0">{{ rp.cpick }}/{{ rp.tpick }}</div>
                  <i *ngIf="roster_removed.indexOf(rp.pname) > -1" class="fas fa-check-circle checkmark"></i>
                </div>    
              </div>
              <div class="filterSearchTeam">
                    <mat-form-field class="searchBar">
                      <mat-label>Search</mat-label>
                      <i matPrefix class="fas fa-search" style="margin-right:10px"></i>
                      <i matSuffix (click)="clearSearch()" [ngStyle]="{'display':search!=null && search != ''?'block':'none'}"
                        class="fas fa-times searchClose"></i>
                      <input matInput type="text" placeholder="Find a player..." [(ngModel)]="search" (keyup)="searchDelay()" />
                    </mat-form-field>
                    &nbsp;
                    <mat-form-field class="teamFilter" *ngIf="league?.game_id != 5 && league?.game_id > 0">
                      <mat-select placeholder="Teams" [(value)]="teamFilter" (selectionChange)="getTablePlayers()">
                        <mat-option *ngFor="let team of teams" [value]="team">
                          {{team}}
                        </mat-option>
                      </mat-select>
                      <button mat-button *ngIf="teamFilter!=null && teamFilter!='ALL'" matSuffix mat-icon-button 
                      aria-label="Clear" (click)="$event.stopPropagation();clearFilter()">
                        <i class="fa fa-times-circle" style="color:var(--text-color2);" aria-hidden="true"></i>
                      </button>
                    </mat-form-field>  
                    <div class="newfilter rankings" (click)="getImportList()" [ngClass]="{'completed':pickInfoBox?.status == 4, 'active':pickInfoBox?.status != 4}">
                      <div class="position">Rankings &nbsp;<i class="fas fa-cloud-download-alt"></i></div>
                    </div>
                    <div class="newfilter rankings active"  (click)="changeView()">
                      <div class="position" *ngIf="currentView=='table'">Slider View &nbsp;<i class="fa fa-ellipsis-h" aria-hidden="true"></i></div>
                      <div class="position" *ngIf="currentView!='table'">Board View &nbsp;<i class="fa fa-th" aria-hidden="true"></i></div>
                    </div>
              </div>
        </div>
    <!-- SEARCH BAR -->
   
    <div class="desktopSeparator">
     
      <!-- HEADERS -->
      <div class="playerHeaders" [ngClass]="{'extracol':(league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0) || (league?.duration_id != 8 && league?.duration_id != 5 && league?.game_id != 5 && league?.game_id > 0)}">
        <div class="header queueStar">{{ (!isMobile)?'':'' }}</div>
        <div class="header name">Player
          <ng-container *ngIf="tableSort != null && tableSort == 'fn'">
            <i [ngClass]="{'fas': true,'fa-sort-down':tableSortOrder == -1,'fa-sort-up':tableSortOrder == 1}"></i>
          </ng-container>
        </div>
        <div class="header"></div>
        <div class="header" *ngIf="league?.game_id != 5 && league?.game_id > 0">
          <!-- {{ (league?.game_id != 5 && league?.game_id > 0) ? 'Pos' : '' }} -->
        </div>
        <div class="header" *ngIf="(league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0) || (league?.duration_id != 8 && league?.duration_id != 5 && league?.game_id != 5 && league?.game_id > 0)">
          {{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0)?'Bye':(league?.duration_id != 8 && league?.duration_id != 5 && league?.game_id != 5 && league?.game_id > 0) ? 'Opp' : '' }}
        </div>
        <div class="header sort" (click)="changeTableFilter(draftData?.col1.col)">{{ draftData?.col1.display }}
          <ng-container *ngIf="tableSort != null && tableSort == draftData?.col1.col">
            <i [ngClass]="{'fas': true,'fa-sort-down':tableSortOrder == -1,'fa-sort-up':tableSortOrder == 1}"></i>
          </ng-container>
        </div>
        <div class="header sort" (click)="changeTableFilter(draftData?.col2.col)">{{ draftData?.col2.display }}
          <ng-container *ngIf="tableSort != null && tableSort == draftData?.col2.col">
            <i
              [ngClass]="{'fas': true,'fa-sort-down':((draftData?.col2.col == 'adp' && tableSortOrder == 1)  || (draftData?.col2.col != 'adp' && tableSortOrder == -1)) ,'fa-sort-up':((draftData?.col2.col == 'adp' && tableSortOrder == -1)  || (draftData?.col2.col != 'adp' && tableSortOrder == 1))}"></i>
          </ng-container>
        </div>
      </div>
      <!-- PLAYERS TABLE -->
      <div class="players" (scroll)="updatePScroll($event)" #playersTable
        [ngStyle]="{'height':getPlayersHeight(playersTable)+'px'}">
        <div class="resetSort" *ngIf="tableSort != null && tableSort != 'order'" (click)="changeTableFilter('order')">
          Reset to Default Order
        </div>
        <div class="hidePlayers" (click)="disableAutoPick()" *ngIf="isAutoPick"
          [ngStyle]="{'height':playersTable.scrollHeight + 'px'}"></div>
        <div class="playerRow" [ngClass]="{'extracol':(league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0) || (league?.duration_id != 8 && league?.duration_id != 5 && league?.game_id != 5 && league?.game_id > 0)}" *ngFor="let player of tablePlayers;let i=index;">
          <ng-container *ngIf="pRowVisible(i,playersTable,'player') && player != null">
            <div class="pSection queueStar">
              
              <i class="queueIcon material-symbols-outlined" (click)="addToQueue(player)"
                [ngClass]="{'active':queue.indexOf(player.id) > -1}">grade</i>
            </div>
            <div class="pSection player">
              <div class="playerImg" *ngIf="!isMobile"
                [ngStyle]="{'background-image':'url(\''+playerURL+player.pp + '?x=123'+'\')'}"></div>
              <div class="text playerName" [matTooltipDisabled]="player.inj == null || player.inj == 'N'"
                [matTooltip]="(player.it != null)?player.it.toUpperCase():''"
                (click)="(player.own == null || player.own != 'yes')?openPlayerInfoBox(player.id,tablePlayers,true,player):null"
                [ngClass]="{'inactive':player.own != null && player.own == 'yes'}"
                [ngStyle]="{'font-size':getNameWidth(player.ln)}">
                <div class="PlayerNameSection" style="display: flex;">
                <div> {{ ((isMobile && player.pn != 'DEF')?player.fn.substr(0,1) + '.' : player.fn) + ' ' + player.ln }}</div>
                  <div *ngIf="player?.inj == 'Y'" class="injuryBubble" [matTooltipDisabled]="player?.inj == null || player?.inj == 'N'"
                  [matTooltip]="(player?.it != null)?player?.it.toUpperCase():''">
                  {{getInjuryAbbr(player?.it)}}
                  </div>
                </div>
                <div>
                  <ng-container *ngIf="league?.game_id != 5">
                  <span class="pos" *ngFor="let pn of getPositions(player.pn); let pi=index;"
                  [ngStyle]="{'color':getPositionColor(pn)}">{{ (pi > 0) ? '/' : '' }}{{ pn }}</span>
                  </ng-container>
                  <div class="position" *ngIf="league?.game_id != 5">{{ player.tn.toUpperCase() }}</div>
                </div>
              </div>
              <div *ngIf="player?.battingSlot > 0 && player?.pty.search(12) > -1" class="battingSlot"> {{ player?.battingSlot }}&nbsp;
                <i class="fa fa-check" aria-hidden="true"></i>
              </div>
              <div *ngIf="player?.startingPitcher > 0" class="startPitch"><i class="fa fa-check" aria-hidden="true"></i></div>
            </div>
            <div class="pSection">
            <div class="draftBtnList" [ngClass]="{'disable':pickInfoBox?.is_active!=1}"  [ngStyle]="{'visibility':pickInfoBox?.is_active!=1?'hidden':'visible'}">
              <button mat-button [disabled]="disableDraft==true" (click)="draftPlayer(player.id,tablePlayers,true,player)">DRAFT</button>
            </div>
          </div>
            <div class="pSection" *ngIf="league?.game_id != 5">
              <!-- <ng-container>
                <span class="pos" *ngFor="let pn of getPositions(player.pn); let pi=index;"
                  [ngStyle]="{'color':getPositionColor(pn)}">{{ (pi > 0) ? '/' : '' }}{{ pn }}</span>
              </ng-container> -->
            </div>
            <div class="pSection" *ngIf="(league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0) || (league?.duration_id != 8 && league?.duration_id != 5 && league?.game_id != 5 && league?.game_id > 0)">{{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0
              )?player.bye: (league?.duration_id != 8 &&
              league?.duration_id != 5 && league?.game_id != 5)?getSchedule(player):'' }}</div>
            <div class="pSection">{{ player[draftData?.col1.col] | number:'1.0-2' }}</div>
            <div class="pSection">{{ player[draftData?.col2.col] | number:'1.0-2' }}</div>
          </ng-container>
        </div>
      </div>
    </div>
    <!-- Roster tab -->
    <mat-tab-group class="tabs" [(selectedIndex)]="selectedTab" (selectedTabChange)="tabChange($event)"   [ngStyle]="{'margin-top':(filters.scrollWidth > filters.clientWidth)?-(56+4)+'px':'-56px'}"
      dynamicHeight="true">
      <mat-tab label="Roster">
        <ng-template matTabContent>
          <div class="rostersTab" #rostersTab [ngStyle]="{'height':getPlayersHeight(rostersTab)+'px'}">
            <div class="teamHeader">
              <div class="body">
                <div class="arrow" (click)="rtIndexChange(false)"><i class="fas fa-chevron-left"></i></div>
                <div class="draftmyteams team">
                  <mat-form-field style="min-width: 15%;max-width:35%;">
                    <mat-select panelClass="myPanelClass" [(value)]="rosterTabIndex" (selectionChange)="rtIndexChange('custom')">
                      <mat-option *ngFor="let team of draftData?.lgm;let indexpos =index" [value]="indexpos">
                        {{team.team_name | uppercase}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="arrow" (click)="rtIndexChange(true)"><i class="fas fa-chevron-right"></i></div>
              </div>
            </div>
            <div class="teamBody">
              <div class="emptyP" *ngIf="isEmptyObject(showRoster)">No Players Drafted Yet</div>
              <ng-container *ngFor="let rp of showRoster | keyvalue:orderKeys">
                <div class="position">
                  <!-- <div class="header">
                    <div class="headerPadding">{{ rp.key }}</div>
                  </div> -->
                  <div class="pRow" *ngFor="let player of rp.value">
                    <!-- <div class="left">
                      <div class="img"
                        [ngStyle]="{'background-image':'url(\''+player.player_picture+'\')', 'border':'2px solid '+player.bgColor}">
                      </div>
                    </div> -->
                    <!-- <div class="right"> -->
                    <div class="pname prostername" (click)="openPlayerInfoBox(player.player_id,tablePlayers,false,{})">
                      <div class="pos" [ngStyle]="{'color':player.bgColor}">{{ player.pname }}</div>
                      <div class="name">{{ player.player }} -
                        {{ player.team }}
                      </div>
                      <div class="bye">
                        {{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0)?'Bye:
                        '+getBye(player.player_id):'' }}
                      </div>
                      <div class="pick">Pick {{ player.round }}.{{ player.pick }}
                        ({{ prettyPrint(player.total_pick) }})
                      </div>
                    </div>
                    <!-- <div class="info">
                      Pick #{{ player.total_pick }} (Round {{ player.round }}, Pick {{ player.pick }})
                    </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <!-- queue tab -->
      
      <mat-tab label="Queue">
        <ng-template mat-tab-label><span [matBadge]="queuePlayers.length" matBadgePosition="above after"
            [matBadgeHidden]="queuePlayers.length == 0">Queue</span></ng-template>
        <ng-template matTabContent>
          <div class="autopickToggle {{browsername}}" *ngIf="draftData?.myteam_id>0">
            <span>Auto Pick </span>
            <mat-slide-toggle class="radioSOY" [(ngModel)]="isAutoPick" #checkbox [checked]="isAutoPick" [disabled]="pickInfoBox?.status == 4" (change)="autoCheckbox(checkbox)">
            </mat-slide-toggle>
          </div>
          <!-- <div class="autopick">
            <mat-checkbox style="padding:5px;" #checkbox [checked]="isAutoPick" (change)="autoCheckbox(checkbox)"
              [disabled]="pickInfoBox?.status == 4" [ngClass]="{'active':isAutoPick}" class="checkbox">
            </mat-checkbox>
          </div> -->
          <div class="queue" #queueTable (scroll)="updateQScroll($event)"
            [ngStyle]="{'height':getPlayersHeight(queueTable)+'px'}" *ngIf="!isMobile" [sortablejs]="queuePlayers"
            [sortablejsOptions]="queueOptions" sortablejsContainer=".queueRow">
            <div class="hidePlayers" (click)="disableAutoPick()" *ngIf="isAutoPick"
              [ngStyle]="{'height':queueTable.scrollHeight + 'px'}"></div>
            <div class="explanation" *ngIf="!queuePlayers.length">
              Press the <i class="queueIcon material-symbols-outlined">grade</i> next to any player.
              <div class="small">Players in your queue will be drafted first by Auto Pick.</div>
            </div>
            <div class="queueRow" *ngFor="let player of queuePlayers;let i=index;">
              <ng-container *ngIf="pRowVisible(i,queueTable,'queue') && player != null">
                <div class="pSection">
                  <div class="dragIcon"></div>
                  <i class="queueIcon material-symbols-outlined" (click)="addToQueue(player)"
                    [ngClass]="{'active':queue.indexOf(player.id) > -1}">grade</i>
                </div>
                <div class="pSection player queuePlayer">
                  <div class="playerImg queuePlayerImg" *ngIf="!isMobile"
                    [ngStyle]="{'background-image':'url(\''+playerURL+player.pp+'\')'}"></div>
                  <div class="text" (click)="openPlayerInfoBox(player.id,queuePlayers,true,player)">
                    {{ breakPlayerName(((isMobile && player.pn != 'DEF')?player.fn.substr(0,1) + '.' : player.fn) + ' ' + player.ln) }}
                  </div>
                </div>
                <div class="draftBtnList" [ngClass]="{'disable':pickInfoBox?.is_active!=1}"  [ngStyle]="{'visibility':pickInfoBox?.is_active!=1?'hidden':'visible'}">
                  <button mat-button [disabled]="disableDraft==true" (click)="draftPlayer(player.id,tablePlayers,true,player)">DRAFT</button>
                </div>
                <div class="pSection">{{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff ==
                  0)?player.bye:'' }}
                </div>
                <div class="pSection">{{ player[draftData?.col1.col] | number:'1.0-2' }}</div>
                <div class="pSection">{{ player[draftData?.col2.col] | number:'1.0-2' }}</div>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </mat-tab>
      <!-- chat tab -->
      <mat-tab>
        <ng-template mat-tab-label><span [matBadge]="unreadMessages" matBadgePosition="above after"
            [matBadgeHidden]="unreadMessages == 0">Chat</span></ng-template>
        <ng-template matTabContent>
          <div class="chat">
            <app-draftchat [league]="league" [drafters_id]="user.drafters_id"></app-draftchat>
          </div>
        </ng-template>
      </mat-tab>
      <!-- info tab -->
      <mat-tab label="Info">
        <ng-template matTabContent>
          <div class="infoContainer" #infoContainer [ngStyle]="{'height':getPlayersHeight(infoContainer)+'px'}">
            <div class="infoTitle" *ngIf="isMobile">
              <div class="icon" [ngStyle]="{'background-image':'url(\''+bucketURL+league?.lg_abbr+'_icon.svg\')'}">
              </div>
              {{ league?.name }}
            </div>
            <div class="game_mode">{{ league?.duration_type }}</div>
            <div class="description">{{ league?.description }}</div>
            <div class="info">
              <div class="sRow" *ngFor="let row of infoTab?.info">
                <div class="left">{{ row.label }}</div>
                <div class="right">{{ row.value + ((row.attribute != '')?' '+row.attribute:'') }}</div>
              </div>
              <ng-container *ngFor="let round of infoTab?.rounds;let i = index;">
                <div class="sRow">
                  <div class="left">{{ round.round }} Date</div>
                  <div class="right">{{ round.round_date }} {{ round.event_text }}</div>
                </div>
                <div class="sRow">
                  <div class="left">{{ round.round }} Draft</div>
                  <div class="right">{{ round.draft_text }}</div>
                </div>
              </ng-container>
            </div>
            <div class="prizes" *ngIf="infoTab?.prize.length">
              <div class="title" (click)="prizesExpand = !prizesExpand">
                Prizes
                <i class="expand fas" [ngClass]="{'fa-sort-down':!prizesExpand, 'fa-sort-up': prizesExpand}"></i>
              </div>
              <div *ngIf="prizesExpand">
                <div class="sRow" *ngFor="let prize of infoTab?.prize">
                  <div class="left">{{ prize.rank }}</div>
                  <div class="right">${{ prize.amount | number:'1.2-2' | Price }}</div>
                </div>
              </div>
            </div>
            <div class="roster">
              <div class="title">{{ (league?.duration_id == 8)?'Roster Minimums (Scored)':'Roster' }}</div>
              <div class="sRow" *ngFor="let row of scoringTab?.roster_positions">
                <div class="left">{{ row.display_name }}</div>
                <div class="right">{{ row.value }}</div>
              </div>
            </div>
            <div class="scoring">
              <div class="title">Scoring</div>
              <div class="category" *ngFor="let cat of scoringTab?.scoring">
                <div class="cTitle">{{ cat.label }}</div>
                <div class="sRow" *ngFor="let row of cat.value">
                  <div class="left">{{ row.display_name }}</div>
                  <div class="right">{{ row.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div class="extraSpacer" *ngIf="isMobile"></div>
  </div>
</div>
<div class="mainMobile" *ngIf="isMobile">
  <mat-tab-group class="tabs" [(selectedIndex)]="selectedTab" (selectedTabChange)="tabChange($event)"
    dynamicHeight="true">
    <mat-tab label="Players">
      <div class="message" [@openMessage]="{'value':isMessage}"
        [ngClass]="{'active':(pickInfoBox?.status == 3 || pickInfoBox?.auto_pause == 1) && slider[currentPick-1]?.lgm_id ==draftData?.myteam_id }">
        <div class="predraft" *ngIf="pickInfoBox?.status == 2">
          <i class="far fa-clock"></i> {{getPickClock(timeleft)}}
          <mat-checkbox [disabled]="readyBox.im_ready" style="margin-left:10px;" (change)="imReady($event)"
            *ngIf="readyBox.status != 0">
            {{ readyBox.message }}</mat-checkbox>
        </div>
        <div class="draftComplete" *ngIf="pickInfoBox?.status == 4">
          DRAFT COMPLETED <i class="check fas fa-check-circle"></i>
        </div>
        <div class="draftPaused" *ngIf="pickInfoBox?.status == 5 && pickInfoBox?.auto_pause == 0">
          DRAFT PAUSED <i class="pause fas fa-pause-circle"></i>
        </div>
        <!-- <div class="totalPlayers"
          *ngIf="(pickInfoBox?.status == 3 || pickInfoBox?.status == 5) && league?.duration_id == 8 && !isAutoPick">
          TOTAL PLAYERS: {{ myPlayersCount() }}/{{ league?.total_players }}
        </div> -->
        <div class="draftPick" *ngIf="(pickInfoBox?.status == 3 ||  pickInfoBox?.auto_pause == 1) && !isAutoPick">
          <span class="clock"><i class="far fa-clock"></i> {{ getPickClock(timeleft) }}</span>{{ getPickMessage() }}
        </div>
        <div class="autopick" *ngIf="isAutoPick && pickInfoBox?.status != 5" (click)="disableAutoPick()">
          <i class="fas fa-exclamation-triangle"></i> Autopick Mode: Click here to disable <i
            class="fas fa-exclamation-triangle"></i>
        </div>
      </div>
      <!-- POSITION FILTERS -->
      <div class="filters" #filters
        [ngStyle]="{'height':(filters.scrollWidth > filters.clientWidth)?(50+scrollBarHeight)+'px':'50px'}">
        <div class="filter" *ngFor="let rp of draftData?.roster_position"
          [ngStyle]="(availRoster(rp.pname))?getStyle(rp.pname):filledPosition"
          [ngClass]="{'filled':!availRoster(rp.pname)}" (click)="(availRoster(rp.pname))?setFilters(rp):null">
          <div class="position" [ngStyle]="{'padding-top':(rp.tpick>0)?'5px':'8px'}">{{ rp.pname }}</div>
          <div class="picked" *ngIf="rp.tpick > 0">{{ rp.cpick }}/{{ rp.tpick }}</div>
          <i *ngIf="roster_removed.indexOf(rp.pname) > -1" class="fas fa-check-circle checkmark"></i>
        </div>
        
        <div class="filter rankings" (click)="getImportList()"
          [ngClass]="{'completed':pickInfoBox?.status == 4, 'active':pickInfoBox?.status != 4}">
          <div class="position"><i class="fas fa-cloud-download-alt"></i></div>
        </div>
      </div>
      <!-- SEARCH BAR -->
      <div class="search">
        <mat-form-field class="searchBar">
          <mat-label>Search</mat-label>
          <i matPrefix class="fas fa-search" style="margin-right:10px"></i>
          <i matSuffix (click)="clearSearch()" [ngStyle]="{'display':search!=null && search != ''?'block':'none'}"
            class="fas fa-times searchClose"></i>
          <input matInput type="text" placeholder="Find a player..." [(ngModel)]="search" (keyup)="searchDelay()" />
        </mat-form-field>
        <mat-form-field *ngIf="league?.game_id != 5 && league?.game_id > 0" class="teamFilter" style="padding-left: 5px;">
        <mat-select placeholder="Teams" [(value)]="teamFilter" (selectionChange)="getTablePlayers()">
          <mat-option *ngFor="let team of teams" [value]="team">
            {{team}}
          </mat-option>
        </mat-select>
        <button mat-button *ngIf="teamFilter!=null && teamFilter!='ALL'" matSuffix mat-icon-button 
        aria-label="Clear" (click)="$event.stopPropagation();clearFilter()">
          <i class="fa fa-times-circle" style="color:var(--text-color2);" aria-hidden="true"></i>
        </button>
      </mat-form-field>
      <!-- <div class="autopickToggle {{browsername}}" *ngIf="draftData?.myteam_id>0">
        <span>Auto Pick </span>
        <mat-slide-toggle class="radioSOY" [(ngModel)]="isAutoPick" #checkbox [checked]="isAutoPick" [disabled]="pickInfoBox?.status == 4" (change)="autoCheckbox(checkbox)">
        </mat-slide-toggle>
      </div> -->
        <!-- <div class="autopick" *ngIf="draftData?.myteam_id>0"> -->
         
          <!-- <mat-checkbox style="padding-right:5px;" #checkbox [checked]="isAutoPick" (change)="autoCheckbox(checkbox)"
            [disabled]="pickInfoBox?.status == 4" [ngClass]="{'active':isAutoPick}" class="checkbox">Auto Pick
          </mat-checkbox> -->
        <!-- </div> -->
        <div class="newfilter rankings active"  (click)="changeView()">
          <div class="position" *ngIf="currentView=='table'">Slider View &nbsp;<i class="fa fa-ellipsis-h" aria-hidden="true"></i></div>
          <div class="position" *ngIf="currentView!='table'">Board View &nbsp;<i class="fa fa-th" aria-hidden="true"></i></div>
        </div>
        <!-- <button mat-button class="tableButton" [ngClass]="{'active':currentView=='table'}" (click)="changeView()">
          <i
            class="fas fa-table"></i>&nbsp;View</button> -->
      </div>
      <!-- HEADERS -->
      <div class="playerHeaders">
        <div class="header">{{ (!isMobile)?'Queue':'' }}</div>
        <div class="header name">Player
          <ng-container *ngIf="tableSort != null && tableSort == 'fn'">
            <i [ngClass]="{'fas': true,'fa-sort-down':tableSortOrder == -1,'fa-sort-up':tableSortOrder == 1}"></i>
          </ng-container>
        </div>
        <div class="header pPos"></div>
        <div class="header">{{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0)?'Bye':
          (league?.duration_id != 8 &&
          league?.duration_id != 5 && league?.game_id != 5 && league?.game_id > 0) ? 'Opp' : '' }}</div>
        <div class="header sHead sort" (click)="changeTableFilter(draftData?.col1.col)">{{ draftData?.col1.display }}
          <ng-container *ngIf="tableSort != null && tableSort == draftData?.col1.col">
            <i [ngClass]="{'fas': true,'fa-sort-down':tableSortOrder == -1,'fa-sort-up':tableSortOrder == 1}"></i>
          </ng-container>
        </div>
        <div class="header sHead sort" (click)="changeTableFilter(draftData?.col2.col)">{{ draftData?.col2.display }}
          <ng-container *ngIf="tableSort != null && tableSort == draftData?.col2.col">
            <i
              [ngClass]="{'fas': true,'fa-sort-down':((draftData?.col2.col == 'adp' && tableSortOrder == 1)  || (draftData?.col2.col != 'adp' && tableSortOrder == -1)) ,'fa-sort-up':((draftData?.col2.col == 'adp' && tableSortOrder == -1)  || (draftData?.col2.col != 'adp' && tableSortOrder == 1))}"></i>
          </ng-container>
        </div>
      </div>
      <!-- PLAYERS TABLE -->
      <div class="players" (scroll)="updatePScroll($event)" #playersTable
        [ngStyle]="{'height':getPlayersHeight(playersTable)+'px'}">
        <div class="resetSort" *ngIf="tableSort != 'order'" (click)="changeTableFilter('order')">
          Reset to Default Order
        </div>
        <div class="hidePlayers" (click)="disableAutoPick()" *ngIf="isAutoPick"
          [ngStyle]="{'height':playersTable.scrollHeight + 'px'}"></div>
        <div class="playerRow" *ngFor="let player of tablePlayers;let i=index;">
          <ng-container *ngIf="pRowVisible(i,playersTable,'player') && player != null">
            <div class="pSection">
              <i class="queueIcon material-symbols-outlined" (click)="addToQueue(player)"
                [ngClass]="{'active':queue.indexOf(player.id) > -1}">grade</i>
            </div>
            <div class="pSection player">
              <div class="playerImg" *ngIf="!isMobile"
                [ngStyle]="{'background-image':'url(\''+playerURL+player.pp+'\')'}"></div>
                <div>
                <div class="text" [matTooltipDisabled]="player.inj == null || player.inj == 'N'"
                  [matTooltip]="player.it.toUpperCase()"
                  (click)="(player.own == null || player.own != 'yes')?openPlayerInfoBox(player.id,tablePlayers,true,player):null"
                  [ngClass]="{'inactive':player.own != null && player.own == 'yes'}"
                  [ngStyle]="{'font-size':getNameWidth(player.ln)}">
                  {{ ((isMobile && player.pn != 'DEF')?player.fn.substr(0,1) + '.' : player.fn) + ' ' + player.ln }}
                  
                  <div *ngIf="player?.startingPitcher > 0" class="startPitch"><i class="fa fa-check" aria-hidden="true"></i></div>
                  <div *ngIf="player?.inj == 'Y'" class="injuryBubble" [matTooltipDisabled]="player?.inj == null || player?.inj == 'N'"
                    [matTooltip]="(player?.it != null)?player?.it.toUpperCase():''">
                    {{getInjuryAbbr(player?.it)}}
                  </div>
                </div>
                 <div>
                <ng-container *ngIf="league?.game_id != 5">
                  <span class="pos" *ngFor="let pn of getPositions(player.pn); let pi=index;"
                    [ngStyle]="{'color':getPositionColor(pn)}">{{ (pi > 0) ? '/' : '' }}{{ pn }}</span>
                </ng-container>
                <div class="position" *ngIf="league?.game_id != 5">{{ player.tn.toUpperCase() }}</div>
                <div *ngIf="player?.battingSlot > 0 && player?.pty.search(12) > -1" class="battingSlot"> {{ player?.battingSlot }}&nbsp;
                  <i class="fa fa-check" aria-hidden="true"></i>
                </div>
              </div>
              </div>
              <!-- <div class="schedule">
                <span class="playerTeam">{{ player.tn.toUpperCase() }}</span>
                {{ (league?.duration_id != 8 && league?.game_id != 5)?getSchedule(player):'' }}
              </div> -->
            </div>
            <div class="pSection pPos">
            
            </div>
            <div class="pSection">{{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0)?player.bye:
              (league?.duration_id != 8 &&
              league?.duration_id != 5 && league?.game_id != 5)?getSchedule(player):'' }}</div>
            <div class="pSection sCol">{{ player[draftData?.col1.col] | number:'1.0-2' }}</div>
            <div class="pSection sCol">{{ player[draftData?.col2.col] | number:'1.0-2' }}</div>
          </ng-container>
        </div>
      </div>
    </mat-tab>
    <!-- queue tab -->
    <mat-tab>
      <ng-template mat-tab-label><span [matBadge]="queuePlayers.length" matBadgePosition="above after"
          [matBadgeHidden]="queuePlayers.length == 0">Queue</span></ng-template>
      <ng-template matTabContent>
        <div class="autopickToggle {{browsername}}" *ngIf="draftData?.myteam_id>0">
          <span>Auto Pick </span>
          <mat-slide-toggle class="radioSOY" [(ngModel)]="isAutoPick" #checkbox [checked]="isAutoPick" [disabled]="pickInfoBox?.status == 4" (change)="autoCheckbox(checkbox)">
          </mat-slide-toggle>
        </div>
        <div class="queue" #queueTable (scroll)="updateQScroll($event)"
          [ngStyle]="{'height':getPlayersHeight(queueTable)+'px'}" [sortablejs]="queuePlayers"
          [sortablejsOptions]="queueOptions" sortablejsContainer=".queueRow">
          <div class="hidePlayers" (click)="disableAutoPick()" *ngIf="isAutoPick"
            [ngStyle]="{'height':queueTable.scrollHeight + 'px'}"></div>
          <div class="explanation" *ngIf="!queuePlayers.length">
            Press the <i class="queueIcon material-symbols-outlined">grade</i> next to any player.
            <div class="small">Players in your queue will be drafted first by Auto Pick.</div>
          </div>
          <div class="queueRow" *ngFor="let player of queuePlayers;let i=index;">
            <ng-container *ngIf="pRowVisible(i,queueTable,'queue') && player != null">
              <div class="pSection">
                <div class="dragIcon"></div>
                <i class="queueIcon material-symbols-outlined" (click)="addToQueue(player)"
                  [ngClass]="{'active':queue.indexOf(player.id) > -1}">grade</i>
              </div>
              <div class="pSection player">
                <div class="playerImg" *ngIf="!isMobile"
                  [ngStyle]="{'background-image':'url(\''+playerURL+player.pp+'\')'}"></div>
                <div class="text" (click)="openPlayerInfoBox(player.id,queuePlayers,true,player)">
                  {{ ((isMobile && player.pn != 'DEF')?player.fn.substr(0,1) + '.' : player.fn) + ' ' + player.ln }}
                </div>
              </div>
              <div class="pSection">{{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff ==
                0)?player.bye:'' }}</div>
              <div class="pSection">{{ player[draftData?.col1.col] | number:'1.0-2' }}</div>
              <div class="pSection">{{ player[draftData?.col2.col] | number:'1.0-2' }}</div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <!-- chat tab -->
    <mat-tab>
      <ng-template mat-tab-label><span [matBadge]="unreadMessages" matBadgePosition="above after"
          [matBadgeHidden]="unreadMessages == 0">Chat</span></ng-template>
      <ng-template matTabContent>
        <div class="chat" #chatTable [ngStyle]="{'height':getPlayersHeight(chatTable)+'px'}">
          <app-draftchat [league]="league" [drafters_id]="user.drafters_id"></app-draftchat>
        </div>
      </ng-template>
    </mat-tab>
    <!-- Roster tab -->
    <mat-tab label="Roster">
      <ng-template matTabContent>
        <div class="rostersTab" #rostersTab [ngStyle]="{'height':getPlayersHeight(rostersTab)+'px'}">
          <div class="teamHeader">
            <div class="body">
              <div class="arrow" (click)="rtIndexChange(false)"><i class="fas fa-chevron-left"></i></div>
              <div class="draftmyteams team">
                <mat-form-field style="min-width: 25%;max-width: 45%;">
                  <mat-select panelClass="myPanelClass" [(value)]="rosterTabIndex" (selectionChange)="rtIndexChange('custom')">
                    <mat-option *ngFor="let team of draftData?.lgm;let indexpos =index" [value]="indexpos">
                      {{team.team_name | uppercase}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="arrow" (click)="rtIndexChange(true)"><i class="fas fa-chevron-right"></i></div>
            </div>
          </div>
          <div class="teamBody">
            <div class="emptyP" *ngIf="isEmptyObject(showRoster)">No Players Drafted Yet</div>
            <ng-container *ngFor="let rp of showRoster | keyvalue:orderKeys">
              <div class="position">
                <!-- <div class="header">
                                  <div class="headerPadding">{{ rp.key }}</div>
                                </div> -->
                <div class="pRow" *ngFor="let player of rp.value">
                  <!-- <div class="left">
                                    <div class="img"
                                      [ngStyle]="{'background-image':'url(\''+player.player_picture+'\')', 'border':'2px solid '+player.bgColor}">
                                    </div>
                                  </div> -->
                  <!-- <div class="right"> -->
                  <div class="pname" (click)="openPlayerInfoBox(player.player_id,tablePlayers,false,{})">
                    <div class="pos" [ngStyle]="{'color':player.bgColor}">{{ player.pname }}</div>
                    <div class="name">{{ player.player }} -
                      {{ player.team }}
                    </div>
                    <div class="bye">
                      {{ (league?.duration_id == 8 && league?.game_id == 2 && league?.bestball_playoff == 0)?'Bye:'+getBye(player.player_id):'' }}
                    </div>
                    <div class="pick">Pick {{ player.round }}.{{ player.pick }} ({{ prettyPrint(player.total_pick) }})
                    </div>
                  </div>
                  <!-- <div class="info">
                                    Pick #{{ player.total_pick }} (Round {{ player.round }}, Pick {{ player.pick }})
                                  </div> -->
                  <!-- </div> -->
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Info">
      <ng-template matTabContent>
        <div class="infoContainer" #infoContainer [ngStyle]="{'height':getPlayersHeight(infoContainer)+'px'}">
          <div class="infoTitle" *ngIf="isMobile">
            <div class="icon" [ngStyle]="{'background-image':'url(\''+bucketURL+league?.lg_abbr+'_icon.svg\')'}"></div>
            {{ league?.name }}
          </div>
          <div class="game_mode">{{ league?.duration_type }}</div>
          <div class="description">{{ league?.description }}</div>
          <div class="info">
            <div class="sRow" *ngFor="let row of infoTab?.info">
              <div class="left">{{ row.label }}</div>
              <div class="right">{{ row.value + ((row.attribute != '')?' '+row.attribute:'') }}</div>
            </div>
            <ng-container *ngFor="let round of infoTab?.rounds;let i = index;">
              <div class="sRow">
                <div class="left">{{ round.round }} Date</div>
                <div class="right">{{ round.round_date }} {{ round.event_text }}</div>
              </div>
              <div class="sRow">
                <div class="left">{{ round.round }} Draft</div>
                <div class="right">{{ round.draft_text }}</div>
              </div>
            </ng-container>
          </div>
          <div class="prizes" *ngIf="infoTab?.prize.length">
            <div class="title" (click)="prizesExpand = !prizesExpand">
              Prizes
              <i class="expand fas" [ngClass]="{'fa-sort-down':!prizesExpand, 'fa-sort-up': prizesExpand}"></i>
            </div>
            <div *ngIf="prizesExpand">
              <div class="sRow" *ngFor="let prize of infoTab?.prize">
                <div class="left">{{ prize.rank }}</div>
                <div class="right">${{ prize.amount | number:'1.2-2' | Price }}</div>
              </div>
            </div>
          </div>
          <div class="roster">
            <div class="title">{{ (league?.duration_id == 8)?'Roster Minimums (Scored)':'Roster' }}</div>
            <div class="sRow" *ngFor="let row of scoringTab?.roster_positions">
              <div class="left">{{ row.display_name }}</div>
              <div class="right">{{ row.value }}</div>
            </div>
          </div>
          <div class="scoring">
            <div class="title">Scoring</div>
            <div class="category" *ngFor="let cat of scoringTab?.scoring">
              <div class="cTitle">{{ cat.label }}</div>
              <div class="sRow" *ngFor="let row of cat.value">
                <div class="left">{{ row.display_name }}</div>
                <div class="right">{{ row.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
  <div class="extraSpacer" *ngIf="isMobile"></div>
</div>
<!-- roster dropdown/popup   -->
<div class="overlay" [ngStyle]="{'display':showModal?'flex':'none'}" (click)="showModal = false">
  <div class="dModal draftedPlayerinfo" [@openModal]="{'value':getModalState(0)}">
    <div class="body " [ngClass]="{'animated-box in':showLoadingBorder}" (click)="$event.stopPropagation()" #screen>
      <div class="headerPart">
      <div class="close" (click)="showModal = false" *ngIf="isMobile">
        <span class=""><i class="fas fa-regular fa-times-circle"></i></span>
        
      </div>
      <div class="row">
      <div class="right">
        <!-- <span class="material-symbols-outlined photo_camera" *ngIf="pickInfoBox?.status == 4 && showCamIcon==true" (click)="showCamIcon=false;downloadImage()">
          photo_camera
          </span> -->
        <img *ngIf="darkMode" [src]="imageData[logoUrl]?imageData[logoUrl]:s3url" width="90px" >
        <img *ngIf="!darkMode" [src]="imageData[logoUrl]?imageData[logoUrl]:bucketURL+'logo-red.png'" width="90px" >
      </div>
    </div>
      <div class="left">
        <p class="dpname">{{ showRosterOwner?.team_name }}</p>
        <p class="leagueName"> {{ league?.name }}</p>
        <!-- {{ league?.entrants }}-Person Draft -->
      </div>
    </div>  
      <div class="roster">
        <div class="dpRoasterData" *ngIf="league?.duration_id == 8">
        <div style="display:inline-block" *ngFor="let rplist of hoverRosterPopup">
          <div class="rpBody" [ngStyle]="{'color':rplist.bgcolor,'display':'inline-block'}">{{ rplist.position }}</div>
          <div class="count">{{rplist.filled}}</div>
        </div>
      </div>
        <div class="pRow " [ngClass]="league?.duration_id == 8?'dplheader':'dplheaderBB'" style="border-bottom: 1px solid transparent !important;">
          <div class="pickRosPos" *ngIf="league?.duration_id != 8"></div>
          <div class="pImg"></div>
          <div class="hname"></div>
          <div class="team"></div>
          <ng-container>
            <div class="bye" *ngIf="league?.bestball_playoff == 0">Bye</div>
            <div class="adp"  [ngStyle]="{'width':league?.bestball_playoff == 0?'14%':'28%'}">ADP</div>  
          </ng-container> 
          <div class="pick">Pick</div>
        </div>
        <ng-container *ngIf="league?.duration_id == 8">
        <ng-container *ngFor="let rp of showRosterNew | keyvalue:orderKeys">
          <div class="position positionAbbr" [ngStyle]="{'color':rp.value[0].bgColor,'float':'left','display':league?.duration_id == 8?'':'none'}">
            <div class="body" [ngStyle]="{'color':rp.value[0].bgColor}">{{ rp.value[0].pname }}</div>
          </div>
          <div class="pRow" [ngClass]="league?.duration_id == 8?'':'prowbb'" [ngStyle]="{'border-bottom':darkMode?'1px solid #ffffff15':'1px solid #92515115'}" *ngFor="let player of rp.value">
            <div class="pickRosPos" *ngIf="league?.duration_id != 8"><div class="" [ngStyle]="{'color':rp.value[0].bgColor,'font-size':rp.value[0].pname.length>3?'12px':''}">{{ rp.value[0].pname }}</div></div>
            <div class="pImg" (click)="openPlayerInfoBox(player.player_id,tablePlayers,false,{})"  style="width:44px;">
              <img alt="{{player.team}}" src="{{imageData[player.profile_image_uri]?imageData[player.profile_image_uri]:player.player_picture}}" style="height:32px;" >
            </div>
            <div class="name"  [ngStyle]="{'font-size':player.player_name_full.length>=18?'10px':''}" (click)="openPlayerInfoBox(player.player_id,tablePlayers,false,{})">{{ isMobile || player.player_name_full.length>=18?player.player:player.player_name_full }}
              <div class="team">{{player.team}}</div>
            </div>
            
            <ng-container>
              <div class="bye" *ngIf="league?.bestball_playoff == 0">{{getBye(player.player_id)}}</div>
              <div class="adp"  [ngStyle]="{'width':league?.bestball_playoff == 0?'14%':'28%'}">{{getAdp(player.player_id) | number :'1.1-1'}}</div>  
            </ng-container>
            <div class="pick">{{ prettyPrint(player.total_pick) }}</div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="league?.duration_id != 8">
          <ng-container *ngFor="let ddrp of draftData?.roster_position">
            <ng-container *ngFor="let rp of showRosterNew | keyvalue:orderKeys">
              <ng-container *ngIf="rp.value[0].pname==ddrp.pname">
                  <div class="position positionAbbr" [ngStyle]="{'color':rp.value[0].bgColor,'float':'left','display':league?.duration_id == 8?'':'none'}">
                    <div class="body" [ngStyle]="{'color':rp.value[0].bgColor}">{{ rp.value[0].pname }}</div>
                  </div>
                  <div class="pRow" [ngClass]="league?.duration_id == 8?'':'prowbb'" [ngStyle]="{'border-bottom':darkMode?'1px solid #ffffff15':'1px solid #92515115'}" *ngFor="let player of rp.value">
                    <div class="pickRosPos" *ngIf="league?.duration_id != 8"><div class="" [ngStyle]="{'color':rp.value[0].bgColor,'font-size':rp.value[0].pname.length>3?'12px':''}">{{ rp.value[0].pname }}</div></div>
                    <div class="pImg" (click)="openPlayerInfoBox(player.player_id,tablePlayers,false,{})" style="width:44px;">
                      <img alt="{{player.team}}" src="{{imageData[player.profile_image_uri]?imageData[player.profile_image_uri]:player.player_picture}}" style="height:32px;">
                    </div>
                    <div class="name" (click)="openPlayerInfoBox(player.player_id,tablePlayers,false,{})">{{ isMobile || player.player_name_full.length>=18?player.player:player.player_name_full }}
                      <div class="team">{{player.team}}</div>
                    </div>
                    
                    <ng-container>
                      <div class="bye" *ngIf="league?.bestball_playoff == 0">{{getBye(player.player_id)}}</div>
                      <div class="adp">{{getAdp(player.player_id) | number :'1.1-1'}}</div>  
                    </ng-container>
                    <div class="pick">{{ prettyPrint(player.total_pick) }}</div>
                  </div>
                  <div *ngFor="let item of [].constructor(ddrp.pick_remain); let i = index" class="pRow minerow" [ngClass]="league?.duration_id == 8?'':'prowbb'" [ngStyle]="{'border-bottom':darkMode?'1px solid #ffffff15':'1px solid #92515115'}"> 
                    <div class="pickRosPos" *ngIf="league?.duration_id != 8">
                    <div class="" [ngStyle]="{'color':getPositionColor(ddrp.pname),'font-size':rp.value[0].pname.length>3?'12px':''}">{{ ddrp.pname }}</div></div>
                    <div class="pImg"></div>
                    <div class="name">
                    <div class="team"></div>
                    </div>
                    <div class="bye"></div>
                    <div class="adp"></div>                         
                  <div class="pick"></div>
                </div>
              </ng-container>
             
          </ng-container>
              <ng-container *ngIf="ddrp.pname!='All' && ddrp.isprinted==false && ddrp.pick_remain>0 && ddrp.tpick>0">
                <div *ngFor="let item of [].constructor(ddrp.pick_remain); let i = index" class="pRow minerow" [ngClass]="league?.duration_id == 8?'':'prowbb'" [ngStyle]="{'border-bottom':darkMode?'1px solid #ffffff15':'1px solid #92515115'}"> 
                      <div class="pickRosPos" *ngIf="league?.duration_id != 8">
                      <div class="" [ngStyle]="{'color':getPositionColor(ddrp.pname),'font-size':ddrp.pname.length>3?'12px':''}">{{ ddrp.pname }}</div></div>
                      <div class="pImg"></div>
                      <div class="name">
                      <div class="team"></div>
                      </div>
                      <div class="bye"></div>
                      <div class="adp"></div>                         
                    <div class="pick"></div>
                  </div>
          </ng-container>
        </ng-container>
      </ng-container>
      </div>
    </div>
    <div class="footer pickinfofotter" (click)="$event.stopPropagation()" *ngIf="pickInfoBox?.status == 4">
      <a mat-button class="btn" [href]="lobbyURL">Back To Lobby</a>
      <!-- <a mat-button class="btn shareBtn" href="javascript:void(0)"  (click)="$event.stopPropagation();showCamIcon=false;downloadImage()" *ngIf="pickInfoBox?.status == 4 && showCamIcon==true">Share  <span class="material-symbols-outlined photo_camera">       photo_camera
        
        </span>
      </a> -->
    </div>
  </div>
</div>
<!-- import rankings dialog -->
<div class="overlay" [ngStyle]="{'display':showRankings?'flex':'none'}" (click)="showRankings = false">
  <div class="dModal" [@openModal]="{'value':getModalState(1)}" [ngStyle]="{'width': (isMobile==true)?'':'50% !important'}">
    <div class="body">
      <div class="close" (click)="showRankings = false" *ngIf="isMobile">
        <span class="cButton"><i class="fas fa-chevron-up"></i></span>
      </div>
      <div class="spacer" style="margin-bottom:45px;width:100%;height:0;" *ngIf="isMobile"></div>
      <!-- <div class="title">Import Rankings</div> -->
      <div style="text-align: center;overflow-y: auto; max-height: 90%;">
        <!-- <div class="oRow" *ngIf="common_rank_id!=0">
          <button mat-button class="reset mat-primary mat-raised-button" (click)="importSet(0)">Reset</button>
        </div> -->
      <div class="oRow" *ngFor="let set of rankingSets">
        <div class="left">
          {{ set.name }}
        </div>
        <div class="right">
          <button mat-button [ngClass]="set.id==common_rank_id?'disabled':'import'" [disabled]="set.id==common_rank_id?true:false" (click)="set.id!=common_rank_id?importSet(set.id):''">{{set.id!=common_rank_id?'Use':'Current'}}</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
<div class="mobileBtns" *ngIf="isMobile">
  <div class="mBtn" (click)="selectedTab = 0" [ngClass]="{'active':selectedTab == 0 || selectedTab == 1}">
    <i class="icon fas fa-user-plus"></i>
    <div class="title">Players</div>
  </div>
  <div class="mBtn" (click)="selectedTab = 2" [ngClass]="{'active':selectedTab == 2}">
    <i class="icon fas fa-comment-alt"></i>
    <div class="title">Chat</div>
  </div>
  <div class="mBtn" (click)="selectedTab = 3" [ngClass]="{'active':selectedTab == 3}">
    <i class="icon fas fa-users"></i>
    <div class="title">Roster</div>
  </div>
  <div class="mBtn" (click)="selectedTab = 4" [ngClass]="{'active':selectedTab == 4}">
    <i class="icon fas fa-info-circle"></i>
    <div class="title">Info</div>
  </div>
</div>
<!-- loading overlay -->
<div class="overlay loadingBox" [ngStyle]="{'display':showLoading?'flex':'none'}">
  <img class="loading" src="assets/images/loadinganim.gif" alt="Loading...">
</div>
<div id="download">
  <img #canvas src="" [ngStyle]="{'display':showCanvas==true?'block':'none'}" />  
  <a #downloadLink></a>
</div>